import type * as React from 'react'
import type { RouteProps } from 'react-router'
import AuthRouteComponent from './AuthRouteComponent'
import TrackedRoute from './TrackedRoute'

interface Props extends RouteProps {
  showPopup?: boolean
  loader?: React.ReactNode
  accountAccessModalInitialMode?: App.UiAccountModalMode
}

function AuthRoute(props: Props) {
  const {
    component,
    children,
    render,
    showPopup,
    loader,
    accountAccessModalInitialMode,
    ...rest
  } = props

  return <TrackedRoute {...rest}>
    {(routeProps) => <AuthRouteComponent
      {...routeProps}
      component={component}
      render={render}
      showPopup={showPopup}
      loader={loader}
      accountAccessModalInitialMode={accountAccessModalInitialMode}
    >
      {children}
    </AuthRouteComponent>}
  </TrackedRoute>
}

export default AuthRoute
